// frontend/src/components/common/riskLevelColumn.js
//
// The `risk_level` column of every stockout grid: one chip, centred, sorted by
// urgency (riskLevels.js) rather than by its label. Hovering its header shows
// what every level means (RiskLegendTooltip). A grid passes only its header name.

import { RiskLevelCell } from './RiskChip';
import RiskLegendTooltip from './RiskLegendTooltip';
import { compareRiskLevels } from './riskLevels';

/**
 * `headerTooltipValueGetter` only decides WHETHER the header tooltip opens —
 * AG Grid skips an empty one — so it returns `true`, not text: the legend is a
 * table of chips, which is what `tooltipComponent` is for. No cell sets a
 * tooltip value, so the component only ever opens on the header.
 */
export function riskLevelColumn({ headerName }) {
  return {
    field: 'risk_level',
    headerName,
    headerTooltipValueGetter: () => true,
    tooltipComponent: RiskLegendTooltip,
    type: 'centeredColumn',
    cellRenderer: RiskLevelCell,
    comparator: compareRiskLevels,
  };
}
